import FilterTag from './FilterTag';

const filterTagData = {
  filterOption: 'Specific Benefits',
  filterInfo: 'Medical',
};

const FilterTagDemo = () => {
  return <FilterTag filter={filterTagData} />;
};

export default FilterTagDemo;
